import React from 'react';
import {
    getCreateDraftUrlFromCategoryId,
    getCreateDraftUrlFromTemplateId,
    getCreateSuggestionUrlFromCategoryId,
    getTemplatesUrlFromCategoryIdAndFolderId,
    getCreateDraftUrlFromFolderId,
    getCreateSuggestionUrlFromCategoryIdAndFolderId,
} from '../../utilities/urlHelper';
import {
    canBulkMove,
    canCreatePage,
    canEditCategory,
    canCreateSubcategory,
    canCreateLink,
    canCreateQuestion,
} from '../../utilities/permissionsUtilities';
import BookmarkItem from '../BookmarkItem';
import CreateSubcategoryWrapper from '../create/CreateSubcategoryWrapper';
import MoveSubcategoryWrapper from '../move/MoveSubcategoryWrapper';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';
import SelectActionButton from './SelectActionButton';
import DeleteCategoryWrapper from '../archive/DeleteCategoryWrapper';

class NewActionDropdown extends React.Component {
    state = {
        templates: null,
    };

    componentDidMount() {
        const { category, subcategory } = this.props;
        const url = subcategory
            ? getTemplatesUrlFromCategoryIdAndFolderId(subcategory.category_id, subcategory.id)
            : `/api/teams/${window.teamId}/categories/${category.id}/templates`;
        $.get(url)
            .done(({ templates }) => this.setState({ templates }));
    }

    render() {
        const { templates } = this.state;
        const { category, subcategory } = this.props;
        const createSuggestionUrl = subcategory
            ? getCreateSuggestionUrlFromCategoryIdAndFolderId(subcategory.category_id, subcategory.id)
            : getCreateSuggestionUrlFromCategoryId(category.id);
        return (
            <div className="dropdown dropdown-right-aligned" data-disclosure>
                <button className="page-list-header-button dropdown-link">
                    New
                    <span className="dropdown-carat" />
                </button>
                <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
                <div data-details className="dropdown-content" style={{ display: 'none' }}>
                    {canCreateQuestion()
                        && (
                            <span className="link dropdown-option category-new-question-link" data-category-id={subcategory ? subcategory.category_id : category.id} data-folder-id={subcategory ? subcategory.id : null}>
                                <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-question.png" alt="" />
                            Question
                            </span>
                        )}
                    {canCreatePage() && (
                        <a className="dropdown-option" href={subcategory ? getCreateDraftUrlFromFolderId(subcategory.id) : getCreateDraftUrlFromCategoryId(category.id)}>
                            <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-page.png" alt="" />
                        Blank page
                        </a>
                    )}
                    {canCreateLink() && (
                        <a className="dropdown-option" data-trigger-add-external-resource data-category={subcategory ? subcategory.category_id : category.id} data-subcategory={subcategory ? subcategory.id : null}>
                            <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-link.png" alt="" />
                        Link
                        </a>
                    )}
                    {canCreateLink() && (
                        <a className="dropdown-option" data-trigger-add-document data-category={subcategory ? subcategory.category_id : category.id} data-subcategory={subcategory ? subcategory.id : null}>
                            <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-document.png" alt="" />
                            Add a document
                        </a>
                    )}
                    {canCreatePage() && (
                        <a className="dropdown-option" data-trigger-import={`{"category": ${subcategory ? subcategory.category_id : category.id}, "folder": ${subcategory ? subcategory.id : null}}`}>
                            <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-page.png" alt="" />
                        Page from import
                        </a>
                    )}
                    {templates
                        && templates.map(template => (
                            <a className="dropdown-option" key={template.id} href={getCreateDraftUrlFromTemplateId(template.id)}>
                                <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-template.png" alt="" />
                                {template.title}
                            </a>
                        ))}
                    {canCreateSubcategory() && <CreateSubcategoryWrapper categoryId={subcategory ? subcategory.category_id : category.id} parentFolderId={subcategory ? subcategory.id : null} parentName={subcategory ? subcategory.name : category.name} />}
                    <a className="dropdown-option" href={createSuggestionUrl}>
                        <img className="flex-none mr2" height="18" width="18" src="/img/icons/file-icon-page-request.png" alt="" />
                        Page request
                    </a>
                    <a className="dropdown-option do-cancel">Cancel</a>
                </div>
            </div>
        );
    }
}

const CategoryOptionDropdown = ({ category }) => (
    <div className="dropdown dropdown-right-aligned" data-disclosure>
        <button className="btn rounded dropdown-link dropdown-elipsis">
            <img className="button-icon" height="20" width="auto" src="/img/icons/dropdown-elipsis.svg" />
        </button>
        <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
        <div data-details className="dropdown-content" style={{ display: 'none' }}>
            <BookmarkItem categoryId={category.id} bookmarkId={window.bookmarkId} />
            {category && canEditCategory() && <MoveSubcategoryWrapper subcategory={category} text="Move category" />}
            {canEditCategory() && (
                <CreateOrEditCategoryWrapper category_id={category.id}>
                    <span className="dropdown-option link">Edit category</span>
                </CreateOrEditCategoryWrapper>
            )}
            {canEditCategory() && <DeleteCategoryWrapper category={category} />}
            <a className="dropdown-option do-cancel">Cancel</a>
        </div>
    </div>
);

const CategoryActions = (props) => (
    <div className="category-buttons">
        {canBulkMove() && <SelectActionButton toggleMoveMode={props.toggleMoveMode} isSelected={props.moveMove} />}
        <NewActionDropdown {...props} />
    </div>
);

export { CategoryOptionDropdown };

export default CategoryActions;
